import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import {PredictCategoryResource, ProfileFamily} from '@/profile-creation-wizard/common/categories/FamiliesCategories';

export type UpdateCategorizationRequest = {
    families: string[];
    categories: string[];
    categorySuggestion: string | null;
};

export type PredictCategoryRequest = {
    headline: string;
    vertical: ProfileCreationFunnelMode;
};

export class CategorizationRepository {
    async getAll(): Promise<HttpServiceResponse<ProfileFamily[]>> {
        return context.httpService.get(context.registry.entries.familiesAndCategories());
    }

    async predict(request: PredictCategoryRequest): Promise<HttpServiceResponse<PredictCategoryResource[]>> {
        return context.httpService.post(context.registry.entries.predictCategories(), request);
    }

    async save(request: UpdateCategorizationRequest): Promise<HttpServiceResponse<void>> {
        return context.httpService.post(context.registry.entries.updateCategorization(), request);
    }
}
